/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ICON_user': {
    width: 24,
    height: 29,
    viewBox: '0 0 24 29',
    data: '<path pid="0" d="M18.5 7a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0zM.5 27c0-2.843.001-4.924.215-6.517.212-1.578.626-2.602 1.396-3.372.77-.77 1.794-1.184 3.372-1.396C7.076 15.501 9.157 15.5 12 15.5c2.843 0 4.924.001 6.517.215 1.578.212 2.602.626 3.372 1.396.77.77 1.184 1.794 1.396 3.372.214 1.593.215 3.674.215 6.517v1.5H.5V27z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/ICON_user.js